import script from "./KAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./KAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./KAvatar.vue?vue&type=style&index=0&id=a94a1f9c&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a94a1f9c"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar});
